var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650 704.168C739.746 704.168 812.5 631.414 812.5 541.668C812.5 451.922 739.746 379.168 650 379.168C560.254 379.168 487.5 451.922 487.5 541.668C487.5 631.414 560.254 704.168 650 704.168Z",
    className: "svgStroke",
    strokeWidth: 60,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650 108.334C535.073 108.334 424.853 153.989 343.587 235.254C262.322 316.52 216.667 426.74 216.667 541.667C216.667 644.151 238.442 711.209 297.917 785.417L650 1191.67L1002.08 785.417C1061.56 711.209 1083.33 644.151 1083.33 541.667C1083.33 426.74 1037.68 316.52 956.413 235.254C875.148 153.989 764.927 108.334 650 108.334V108.334Z",
    className: "svgStroke",
    strokeWidth: 60,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsLocation);
export default __webpack_public_path__ + "static/media/akar-icons_location.c8bdc41c.svg";
export { ForwardRef as ReactComponent };